import React from 'react';

const BreadCrumbsContext = React.createContext({
  breadcrumbsList: [],
  // eslint-disable-next-line no-unused-vars
  setBreadcrumbsList: (breadcrumbsList) => {},
});

export default BreadCrumbsContext;
